module.exports = __webpack_public_path__ + "static/DSC_9390-5d6d8af91dcc5c14531c175da2da4237.jpg";